export function formatCurrencyV1(value: number | string, opt = {}) {
    let options = {
        style: 'currency',
        currency: 'INR',
        significantDigits: 2,
        thousandsSeparator: ',',
        decimalSeparator: '.',
        symbol: '₹',
    };
    if (typeof value !== 'number') value = 0.0;
    options = { ...options, ...opt };
    let actual = value;
    value = Number(value) < 0 ? Math.abs(value) : value;
    value = value?.toFixed(options?.significantDigits);

    const [currency, decimal] = value?.split('.');
    return Number(actual) < 0
        ? `- ${options?.symbol}${currency?.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              options?.thousandsSeparator,
          )}${decimal ? `.${decimal}` : ``}`
        : `${options?.symbol}${currency?.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              options?.thousandsSeparator,
          )}${decimal ? `.${decimal}` : ``}`;
}

export const currencyFormatWithoutDecimal = {
    style: 'currency',
    currency: 'INR',
    significantDigits: 0,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbol: '₹',
};
